// Packages and components
import React, { useState } from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDImage from '@ui/Image/SHDImage';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDSelectable from '@ui/Selectable/SHDSelectable';
import SHDText from '@ui/Text/SHDText';

// Types
import type { HowWillYouScorePageProps } from '../Onboarding.d';

const HowWillYouScorePage: React.FC<HowWillYouScorePageProps> = ({
  onContinue,
  modalHeight,
}) => {
  // States
  const [inviteManager, setInviteManager] = useState<boolean>(false);

  return (
    <Box height={modalHeight}>
      <SHDModalContainer>
        <Box gap="xsmall" margin={{ bottom: 'xxxlarge' }}>
          <Box width="60%">
            <SHDHeading level={3}>How will you score the game?</SHDHeading>
          </Box>
          <SHDText color="gray-900-alpha-80" style="subhead">
            You&apos;ll need a second device to score the game. Scoring the game
            is how players get clips of their plays.
          </SHDText>
        </Box>

        <Box gap="small" direction="column">
          <Box
            width="100%"
            direction="row"
            margin={{ horizontal: 'auto', vertical: '0px' }}
          >
            <SHDSelectable
              isActive={inviteManager === false}
              id="noInvite"
              onSelected={() => setInviteManager(false)}
              pad={{ vertical: 'small', horizontal: 'large' }}
              round="16px"
            >
              <Box
                align="start"
                justify="start"
                width="100%"
                direction="column"
                gap="xsmall"
              >
                <SHDImage
                  alt={`Device icon`}
                  className="device-icon"
                  color="black"
                  src={`/icons/device.svg`}
                  width={20}
                />
                <SHDText style="subhead-bold">
                  Using another device of my own
                </SHDText>
              </Box>
            </SHDSelectable>
          </Box>

          <Box width="100%" margin={{ horizontal: 'auto', vertical: '0px' }}>
            <SHDSelectable
              id="invite"
              isActive={inviteManager === true}
              onSelected={() => setInviteManager(true)}
              pad={{ vertical: 'small', horizontal: 'large' }}
              round="16px"
            >
              <Box
                align="start"
                justify="start"
                width="100%"
                direction="column"
                gap="xsmall"
              >
                <SHDImage
                  alt={`Group icon`}
                  className="group-icon"
                  color="black"
                  src={`/icons/group.svg`}
                  width={39}
                />
                <SHDText style="subhead-bold">Someone else will help</SHDText>
              </Box>
            </SHDSelectable>
          </Box>
        </Box>
      </SHDModalContainer>
      <SHDFooter>
        <SHDModalContainer>
          <SHDButton
            primary
            label="Next"
            onClick={() => {
              onContinue && onContinue(inviteManager);
            }}
          />
        </SHDModalContainer>
      </SHDFooter>
    </Box>
  );
};

export default HowWillYouScorePage;
